<template>

  <!-- 最新年度の実績 -->
  <div>

    <!-- 実績値エラー表示 -->
    <div class="l-contentsSection error" 
      v-if="$v.femalePercentage.regularMaleEmployee.$invalid 
      || $v.femalePercentage.regularFemaleEmployee.$invalid 
      || $v.femalePercentage.nonRegularMaleEmployee.$invalid
      || $v.femalePercentage.nonRegularFemaleEmployee.$invalid
      || $v.femalePercentage.regularMaleNewEmployee.$invalid
      || $v.femalePercentage.regularFemaleNewEmployee.$invalid
      || $v.femalePercentage.resultMemo.$invalid 
      || $v.femalePercentage.actionMemo.$invalid">

      <div v-if="$v.femalePercentage.regularMaleEmployee.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">男女別新規採用数（正社員・男性）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.femalePercentage.regularMaleEmployee.$invalid && !$v.femalePercentage.regularMaleEmployee.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.femalePercentage.regularMaleEmployee.$invalid && $v.femalePercentage.regularMaleEmployee.numeric && !$v.femalePercentage.regularMaleEmployee.between" validation="between" valueMin="0" valueMax="9999"/>
      </div>

      <div v-if="$v.femalePercentage.nonRegularMaleEmployee.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">男女別新規採用数（非正規・男性）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.femalePercentage.nonRegularMaleEmployee.$invalid && !$v.femalePercentage.nonRegularMaleEmployee.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.femalePercentage.nonRegularMaleEmployee.$invalid && $v.femalePercentage.nonRegularMaleEmployee.numeric && !$v.femalePercentage.nonRegularMaleEmployee.between" validation="between" valueMin="0" valueMax="9999"/>
      </div>

      <div v-if="$v.femalePercentage.regularFemaleEmployee.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">男女別新規採用数（正社員・女性）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.femalePercentage.regularFemaleEmployee.$invalid && !$v.femalePercentage.regularFemaleEmployee.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.femalePercentage.regularFemaleEmployee.$invalid && $v.femalePercentage.regularFemaleEmployee.numeric && !$v.femalePercentage.regularFemaleEmployee.between" validation="between" valueMin="0" valueMax="9999"/>
      </div>

      <div v-if="$v.femalePercentage.nonRegularFemaleEmployee.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">男女別新規採用数（非正規・女性）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.femalePercentage.nonRegularFemaleEmployee.$invalid && !$v.femalePercentage.nonRegularFemaleEmployee.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.femalePercentage.nonRegularFemaleEmployee.$invalid && $v.femalePercentage.nonRegularFemaleEmployee.numeric && !$v.femalePercentage.nonRegularFemaleEmployee.between" validation="between" valueMin="0" valueMax="9999"/>
      </div>

      <div v-if="$v.femalePercentage.regularMaleNewEmployee.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">男女別新規採用数（新卒・男性）　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.femalePercentage.regularMaleNewEmployee.$invalid && !$v.femalePercentage.regularMaleNewEmployee.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.femalePercentage.regularMaleNewEmployee.$invalid && $v.femalePercentage.regularMaleNewEmployee.numeric && !$v.femalePercentage.regularMaleNewEmployee.between" validation="between" valueMin="0" valueMax="9999"/>
      </div>

      <div v-if="$v.femalePercentage.regularFemaleNewEmployee.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">男女別新規採用数（新卒・女性）　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.femalePercentage.regularFemaleNewEmployee.$invalid && !$v.femalePercentage.regularFemaleNewEmployee.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.femalePercentage.regularFemaleNewEmployee.$invalid && $v.femalePercentage.regularFemaleNewEmployee.numeric && !$v.femalePercentage.regularFemaleNewEmployee.between" validation="between" valueMin="0" valueMax="9999"/>
      </div>

      <div v-if="$v.femalePercentage.resultMemo.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">実績に関するメモ：</span>
        <ValidationErrorMessage v-show="$v.femalePercentage.resultMemo.$invalid && !$v.femalePercentage.resultMemo.maxLength" validation="maxLength" valueLength="300" />
      </div>
      <div v-if="$v.femalePercentage.actionMemo.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">具体的なアクション：</span>
        <ValidationErrorMessage v-show="$v.femalePercentage.actionMemo.$invalid && !$v.femalePercentage.actionMemo.maxLength" validation="maxLength" valueLength="300" />
      </div>
    </div>

    <!-- 実績値入力 -->
    <div class="human-capitalt-data-wrap">
      <div class="human-capitalt-data-wrap__table02">
        <p class="l-formGroup__label u-mb10">男女別新規採用数</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 16%;">
            <col style="width: 44%;">
            <col style="width: 20%;">
            <col style="width: 20%;">
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>正社員</th>
              <th>非正規社員</th>
              <th>全社</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>男性</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.femalePercentage.$model.regularMaleEmployee" type="text" name="femalePercentage.regularMaleEmployee" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                  <span class="human-capitalt-data-table__unit">（内新卒</span>
                  <TextBox v-model.trim="$v.femalePercentage.$model.regularMaleNewEmployee" type="text" name="femalePercentage.regularMaleNewEmployee" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名）</span>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.femalePercentage.$model.nonRegularMaleEmployee" type="text" name="femalePercentage.nonRegularMaleEmployee" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfMaleEmployee" :unit="this.unit1"/></span>
              </td>
            </tr>
            <tr>
              <th>女性</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.femalePercentage.$model.regularFemaleEmployee" type="text" name="femalePercentage.regularFemaleEmployee" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                  <span class="human-capitalt-data-table__unit">（内新卒</span>
                  <TextBox v-model.trim="$v.femalePercentage.$model.regularFemaleNewEmployee" type="text" name="femalePercentage.regularFemaleNewEmployee" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名）</span>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.femalePercentage.$model.nonRegularFemaleEmployee" type="text" name="femalePercentage.nonRegularFemaleEmployee" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfFemaleEmployee" :unit="this.unit1"/></span>
              </td>
            </tr>
            <tr class="human-capitalt-data-table__bordertop">
              <th>合計</th>
              <td>
                <span class="human-capitalt-data-table__text">
                  <Currency :value="this.sumOfRegularEmployee" :unit="this.unit1"/>
                  （内新卒<Currency :value="this.sumOfRegularNewEmployee" :unit="this.unit1"/>)
                </span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfNonRegularEmployee" :unit="this.unit1"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfAllEmployee" :unit="this.unit1"/></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table01-->

      <div class="human-capitalt-data-wrap__arrow"></div>
      <div class="human-capitalt-data-wrap__results">
        <div class="human-capitalt-data-results">
          <div class="human-capitalt-data-results__text">
            採用女性労働者割合
            <strong><Currency :value="this.calFemalePercentage"/></strong>%
          </div>
        </div>
      </div>
    </div><!--/human-capitalt-data-wrap-->
    <div class="l-contentsGrid2 u-mt30">
      <div class="l-contentsGrid2__item">
        <div>
          <div class="l-formGroup">
            <label class="l-formGroup__label u-mb10">実績に関するメモ</label>
            <p v-if="this.num==0" class="l-memo-note">現状の課題や、課題に対してのアドバイスをメモしましょう。</p>
              <TextArea class="l-formGroup__textArea is-highMiddle" v-model="femalePercentage.resultMemo" @input="changeInput()" ></TextArea>
          </div>
        </div>
      </div>
      <div class="l-contentsGrid2__item">
        <div class="l-contentsMemo" ref="memoEdit">
          <div class="l-formGroup">
            <div class="l-contentsMemo__title">
              <label class="l-formGroup__label">具体的なアクション</label>
              <button class="link-arrow is-normal js-memo-edit" @click="editMode()">編集する</button>
              <button class="link-arrow is-edit js-memo-exit" @click="editMode()">編集を終わる</button>
            </div>
            <p v-if="this.num==0" class="l-memo-note">今後どういった取り組みをしていくかをメモしましょう。<br>レポート画面からも入力できます。</p>
            <div class="l-contentsMemo__body">
              <div class="l-grayBox is-normal" style="min-height:108px;">
                <div>
                  <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(femalePercentage.actionMemo)"></p>
                </div>
              </div>
            </div>
            <TextArea class="l-formGroup__textArea is-highMiddle is-edit" v-model="femalePercentage.actionMemo" @input="changeInput()"></TextArea>
          </div>
        </div>
      </div>
    </div><!--/l-contentsGrid2-->
  </div>
</template>

<script>
import TextBox from '@/components/parts/form/TextBox.vue';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import TextArea from '@/components/parts/form/TextArea.vue';
import { numeric, between, maxLength } from 'vuelidate/lib/validators';
import Currency from '@/components/parts/human_capital/parts/Currency.vue';

export default {
  components: {
    TextBox,
    ValidationErrorMessage,
    TextArea,
    Currency,
  },
  props: {
    // 表示年度の財務情報データ
    femalePercentage: {},
    num: null,
  },
  data() {
    return {
      isAnswerChanged:false,
      unit1: "名",
      unit2: "％",
    }
  },
  computed: {
    sumOfMaleEmployee() {
      if ( !(this.femalePercentage.regularMaleEmployee!=null && this.femalePercentage.nonRegularMaleEmployee!=null) ) {
        return null;
      }else if ( String(this.femalePercentage.regularMaleEmployee).length * String(this.femalePercentage.nonRegularMaleEmployee).length == 0) {
        return null;
      }else if ( isNaN(this.femalePercentage.regularMaleEmployee) || isNaN(this.femalePercentage.nonRegularMaleEmployee)) {
        return null;
      }else{
        return Number(this.femalePercentage.regularMaleEmployee) + Number(this.femalePercentage.nonRegularMaleEmployee);
      }
    },
    sumOfFemaleEmployee() {
      if ( !(this.femalePercentage.regularFemaleEmployee!=null && this.femalePercentage.nonRegularFemaleEmployee!=null) ) {
        return null;
      }else if ( String(this.femalePercentage.regularFemaleEmployee).length * String(this.femalePercentage.nonRegularFemaleEmployee).length == 0 ) {
        return null;
      }else if ( isNaN(this.femalePercentage.regularFemaleEmployee) || isNaN(this.femalePercentage.nonRegularFemaleEmployee)) {
        return null;
      }else{
        return Number(this.femalePercentage.regularFemaleEmployee) + Number(this.femalePercentage.nonRegularFemaleEmployee);
      }
    },

    sumOfRegularNewEmployee() {
      if ( !(this.femalePercentage.regularMaleNewEmployee!=null && this.femalePercentage.regularFemaleNewEmployee!=null) ) {
        return null;
      }else if ( String(this.femalePercentage.regularMaleNewEmployee).length * String(this.femalePercentage.regularFemaleNewEmployee).length == 0 ) {
        return null;
      }else if ( isNaN(this.femalePercentage.regularMaleNewEmployee) || isNaN(this.femalePercentage.regularFemaleNewEmployee)) {
        return null;
      }else{
        return Number(this.femalePercentage.regularMaleNewEmployee) + Number(this.femalePercentage.regularFemaleNewEmployee);
      }
    },

    sumOfRegularEmployee() {
      if ( !(this.femalePercentage.regularMaleEmployee!=null && this.femalePercentage.regularFemaleEmployee!=null) ) {
        return null;
      }else if ( String(this.femalePercentage.regularMaleEmployee).length * String(this.femalePercentage.regularFemaleEmployee).length == 0 ) {
        return null;
      }else if ( isNaN(this.femalePercentage.regularMaleEmployee) || isNaN(this.femalePercentage.regularFemaleEmployee)) {
        return null;
      }else{
        return Number(this.femalePercentage.regularMaleEmployee) + Number(this.femalePercentage.regularFemaleEmployee);
      }
    },
    sumOfNonRegularEmployee() {
      if ( !(this.femalePercentage.nonRegularMaleEmployee!=null && this.femalePercentage.nonRegularFemaleEmployee!=null) ) {
        return null;
      }else if ( String(this.femalePercentage.nonRegularMaleEmployee).length * String(this.femalePercentage.nonRegularFemaleEmployee).length == 0 ) {
        return null;
      }else if ( isNaN(this.femalePercentage.nonRegularMaleEmployee) || isNaN(this.femalePercentage.nonRegularFemaleEmployee)) {
        return null;
      }else{
        return Number(this.femalePercentage.nonRegularMaleEmployee) + Number(this.femalePercentage.nonRegularFemaleEmployee);
      }
    },
    sumOfAllEmployee() {
      if ( !(this.sumOfRegularEmployee!=null && this.sumOfNonRegularEmployee!=null) ) {
        return null;
      }else {
        return Number(this.sumOfRegularEmployee) + Number(this.sumOfNonRegularEmployee);
      }
    },
    calFemalePercentage() {

      if ( this.sumOfAllEmployee == 0 ) return null;
      if ( this.sumOfFemaleEmployee == 0 ) return 0;

      if ( this.sumOfFemaleEmployee != null && this.sumOfAllEmployee != null ){
        let val = (this.sumOfFemaleEmployee / this.sumOfAllEmployee) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }else{
        return null;
      }
    }
  },
  validations: {
    femalePercentage: {
      regularMaleEmployee : { numeric, between: between(0,9999) },         // 採用女性労働者割合（正社員・男性）
      regularFemaleEmployee : { numeric, between: between(0,9999) },       // 採用女性労働者割合（正社員・女性）
      nonRegularMaleEmployee : { numeric, between: between(0,9999) },      // 採用女性労働者割合（非正規社員・男性）
      nonRegularFemaleEmployee : { numeric, between: between(0,9999) },    // 採用女性労働者割合（非正規社員・女性）
      regularMaleNewEmployee : { numeric, between: between(0,9999) },      // 採用女性労働者割合（新卒・男性）
      regularFemaleNewEmployee : { numeric, between: between(0,9999) },    // 採用女性労働者割合（新卒・女性）
      resultMemo: { maxLength: maxLength(300) }, // 実績メモ
      actionMemo: { maxLength: maxLength(300) }, // アクションメモ
    }
  },
  watch: {
    femalePercentage() {
      this.inputFemalePercentage();
    }
  },
  created: function () {

  },
  mounted() {

  },
  methods: {
    inputFemalePercentage() {
      this.$emit("change-female-percentage", {
        femalePercentage: this.femalePercentage,
        num: this.num,
      });
    },
    // アクションメモの編集モード切替
    editMode(isEdit){
      const memoElm = this.$refs.memoEdit
      if ( isEdit == null || memoElm.classList.contains("is-edit") ){
        memoElm.classList.toggle("is-edit");
      }
    },
    // 文字列中のURLをaタグに変換する
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },
    // 編集フラグの取得（メイン画面の画面遷移時に呼び出されてチェックする）
    getIsAnswerChanged(){
      return this.isAnswerChanged; 
    },
    // 入力データ編集フラグ
    changeInput(){
      this.isAnswerChanged = true
    },
    setIsAnswerChanged(flag){
      this.isAnswerChanged = flag;
    }
  }
}

</script>
